import CanvasObject from './CanvasObject';
import { BoundingBox } from './CanvasObject';

export default class CanvasTimeIndicator extends CanvasObject {

  constructor(x, y, width, height, canvas) {
    super(canvas, {x, y, width, height, draggable: true, type: 'custom', constraints: {
      minX: 0,
      maxX: canvas.width,
      axis: 'x'
    }}, {}, {'skipMeForNearObjs': true});
    this.canvas = canvas;
    this.boundingBox = new BoundingBox(this, {offsets: {x: -5, y: -5}});
    this.init();
  }

  init() {
    this.on('focus', (e) => {
      this.select();
    })
    this.on('unfocus', (e) => {
      this.deselect();
    })
  }

  select() {
    this.selected = true;
  }

  deselect() {
    this.selected = false;
  }

  draw(context) {
    const x = this.x;
    const y = this.y;

    context.save();
    context.globalCompositeOperation = 'source-over'
    if(this.selected)
      context.fillStyle = 'white';
    else context.fillStyle = 'rgba(255, 255, 255, 0.2)'
    context.beginPath();
    context.translate(x, y - 2);
    context.rotate(Math.PI / 4);
    context.fillRect(0, 0, 10, 10);
    context.restore();

    context.save();
    if(this.selected)
      context.strokeStyle = 'white';
    else context.strokeStyle = 'rgba(255, 255, 255, 0.2)'
    context.lineWidth = 0.3;
    context.beginPath();
    context.moveTo(x, y - 2);
    context.lineTo(x, this.canvas.yCoord(this.canvas.height + 50));
    context.stroke();
    context.restore();
  }

}



// WEBPACK FOOTER //
// ./src/components/canvas/objects/CanvasTimeIndicator.js